export default [
  { id: 1, name: 'Администрация' },
  { id: 2, name: 'Служба ИТ' },
  { id: 3, name: 'Служба логистики' },
  { id: 4, name: 'Служба по работе с государственными органами' },
  { id: 5, name: 'Служба производства' },
  { id: 6, name: 'Служба развития и управления проектами' },
  { id: 7, name: 'Техническая служба' },
  { id: 8, name: 'Служба управления качеством' },
  { id: 9, name: 'Служба управления персоналом' },
  { id: 10, name: 'Служба финансов' },
];
